export const findElementByKey = <A extends any[], I extends A[number], K extends keyof I>(
  array: A,
  key: K,
  value: A[number][K],
): I => array.find((element) => element[key] === value);
